import React from "react";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    OutlinedInput,
    Button,
    TableCell,
    Table,
    TableHead,
    TableRow,
    TableBody
} from '@mui/material'
import PriceModal from './PriceModal'
import EventOptionAvailabilityTypes from '../../../models/EventOptionAvailabilityTypes';
import MemberGroupTypes from '../../../models/MemberGroupTypes';
import EventPriceDefinitions from '../../../models/EventPriceDefinitions';
import EditIcon from '@mui/icons-material/Edit'
import CloseIcon from '@mui/icons-material/Close'
import MemberAgeGroups from '../../../models/MemberAgeGroups';
import EventOptions from '../../../models/EventOptions';

const ColumnNames: string[] = ['Teilnehmergruppe', 'Altersklasse', 'Verfügbarkeit', 'Veranstaltung', 'Preis', 'Aktionen']

class Prices extends React.Component<any, any>  {

    componentDidMount() {
        this.props.fetch()
        this.props.fetchEventOptions()
        this.props.fetchAgeGroups()
    }

    public render() {
        let columns: JSX.Element[] = ColumnNames.map(x => {
            return <TableCell key={x}>{x}</TableCell>
        })

        // mapping to MenuItems for filters
        let availabilityTypes: JSX.Element[] = (this.props.availabilityTypes as EventOptionAvailabilityTypes[]).map(x => {
            return <MenuItem key={x.id} value={x.id}>{x.description}</MenuItem>
        })

        let groupTypes: JSX.Element[] = (this.props.groupTypes as MemberGroupTypes[]).map(x => {
            return <MenuItem key={x.id} value={x.id}>{x.groupName}</MenuItem>
        })

        let ageGroups: JSX.Element[] = (this.props.ageGroups as MemberAgeGroups[]).map(x => {
            return <MenuItem key={x.id} value={x.id}>{x.groupName}</MenuItem>
        })

        let eventOptions: JSX.Element[] = (this.props.eventOptions as EventOptions[]).map(x => {
            return <MenuItem key={x.id} value={x.id}>{x.description}</MenuItem>
        })

        let priceValues: JSX.Element[] = (this.props.priceValues as number[]).map(x => {
            return <MenuItem key={x} value={x}>{`€ ${x.toFixed(2).replace('.',',')}`}</MenuItem>
        })

        let rows: JSX.Element[] = (this.props.priceDefinitions as EventPriceDefinitions[]).map(x => {
            return <TableRow key={x.id}>
                <TableCell>{x.memberGroupTypeName}</TableCell>
                <TableCell>{x.memberAgeGroupName}</TableCell>
                <TableCell>{x.availabilityType}</TableCell>
                <TableCell>{x.eventOption}</TableCell>
                <TableCell>{`€ ${typeof x.priceValue != 'undefined' && x.priceValue ? x.priceValue.toFixed(2).replace('.',',') : '0,-'}`}</TableCell>
                <TableCell>
                    <EditIcon className='icon' onClick={() => {
                        this.props.changeMethod('Edit')
                        this.props.changeObject(x)
                        this.props.showModal()
                    }}/>
                    <CloseIcon className='icon' onClick={() => {
                        this.props.delete(x.id)
                    }}/>
                </TableCell>
            </TableRow>
        })

        return (
            <>
            <div className='card'>
                <div className='card-header'>
                    Preise
            </div>
                <div className='card-body'>
                    <div className='row mt-3 mb-3 ml-2'>
                        <div className='float-right'>
                            <Button 
                                variant='contained' 
                                color='primary' 
                                className='btnBlue' 
                                onClick={() => {
                                    this.props.changeMethod('Submit')
                                    this.props.showModal()
                                }}>Hinzufügen</Button>
                        </div>
                    </div>
                    <hr/>
                    <strong>Filter:</strong>
                    <div className='row'>
                        <div className='col-sm-6'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-aktiv">
                                    Teilnehmergruppe
                            </InputLabel>
                                <Select
                                    input={
                                        <OutlinedInput id='outlined-aktiv' fullWidth />
                                    }
                                    name='memberGroupId'
                                    value={typeof this.props.filter.memberGroupId !== 'undefined' ? this.props.filter.memberGroupId : ''}
                                    onChange={(e:any) => this.props.handleChangeFilter(e)}
                                    fullWidth >
                                    <MenuItem value="">
                                        <em></em>
                                    </MenuItem>
                                    {groupTypes}
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-sm-6'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-aktiv">
                                    Verfügbarkeit
                            </InputLabel>
                                <Select
                                    input={
                                        <OutlinedInput id='outlined-aktiv' fullWidth />
                                    }
                                    name='availabilityTypeId'
                                    value={typeof this.props.filter.availabilityTypeId !== 'undefined' ? this.props.filter.availabilityTypeId : ''}
                                    onChange={(e:any) => this.props.handleChangeFilter(e)}
                                    fullWidth >
                                    <MenuItem value="">
                                        <em></em>
                                    </MenuItem>
                                    {availabilityTypes}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-6'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-aktiv">
                                    Altersklasse
                                </InputLabel>
                                <Select
                                    input={
                                        <OutlinedInput id='outlined-aktiv' fullWidth />
                                    }
                                    name='memberAgeGroupId'
                                    value={typeof this.props.filter.memberAgeGroupId !== 'undefined' ? this.props.filter.memberAgeGroupId : ''}
                                    onChange={(e:any) => this.props.handleChangeFilter(e)}
                                    fullWidth >
                                    <MenuItem value="">
                                        <em></em>
                                    </MenuItem>
                                    {ageGroups}
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-6'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-aktiv">
                                    Veranstaltung
                                </InputLabel>
                                <Select
                                    input={
                                        <OutlinedInput id='outlined-aktiv' fullWidth />
                                    }
                                    name='eventOptionId'
                                    value={typeof this.props.filter.eventOptionId !== 'undefined' ? this.props.filter.eventOptionId : ''}
                                    onChange={(e:any) => this.props.handleChangeFilter(e)}
                                    fullWidth >
                                    <MenuItem value="">
                                        <em></em>
                                    </MenuItem>
                                    {eventOptions}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-6'>
                        <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-aktiv">
                                    Preis
                                </InputLabel>
                                <Select
                                    input={
                                        <OutlinedInput id='outlined-aktiv' fullWidth />
                                    }
                                    name='price'
                                    value={typeof this.props.filter.price !== 'undefined' ? this.props.filter.price : ''}
                                    onChange={(e:any) => this.props.handleChangeFilter(e)}
                                    fullWidth >
                                    <MenuItem value="">
                                        <em></em>
                                    </MenuItem>
                                    {priceValues}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className='float-right mt-4'>
                        <Button
                            variant='contained'
                            color='primary'
                            className='btnBlue'
                            onClick={() => this.props.fetch(this.props.filter)}
                        >Suchen
                        </Button>
                        <Button
                            className='ml-2 btnBlue'
                            color='primary'
                            variant='contained'
                            onClick={() => this.props.clearFilter()}
                        >Zurücksetzen</Button>
                    </div>
                </div>
            </div>
            <div className='row mt-3'>
                <Table className="objects-table table">
                    <TableHead>
                        <TableRow>
                            {columns}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows}
                    </TableBody>
                </Table>
            </div>
                    {
            this.props.modal &&
                <PriceModal
                    hide={this.props.hideModal}
                    groupTypes={this.props.groupTypes}
                    ageGroups={this.props.ageGroups}
                    eventOptions={this.props.eventOptions}
                    availabilityTypes={this.props.availabilityTypes}
                    newObject={this.props.newObject}
                    changeNewObject={this.props.changeNewObject}
                    submit={this.props.submit}
                    requiredFields={this.props.priceDefRequiredFields}
                    method={this.props.method}
                />
        }
        </>
        )
    }
}

export default Prices